import apiClient from '@u/apiClient'
import GetInvoicingCategoryListController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/GetInvoicingCategoryListController'
import GetInvoicingCategoryByIdController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/GetInvoicingCategoryByIdController'
import CreateInvoicingCategoryController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/CreateInvoicingCategoryController'
import UpdateInvoicingCategoryController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/UpdateInvoicingCategoryController'
import UpdateMultipleInvoicingCategoryController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/UpdateMultipleInvoicingCategoryController'
import DeleteInvoicingCategoryController from '@/wayfinder/actions/App/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
// import router from '@/router'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchInvoicingCategoryIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetInvoicingCategoryListController.get())
      .then(async (response) => {
        await commit(
          'setInvoicingCategoryList',
          response.data.invoicing_categories
        )
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchInvoicingCategoryIndex', reason)
      })
  },
  async fetchInvoicingCategoryByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetInvoicingCategoryByIdController.get({ invoicing_category: id }))
      .then(async (response) => {
        commit('setInvoicingCategory', response.data.invoicing_category)
      })
      .catch(async (reason) => {
        console.error('fetchInvoicingCategoryByID', reason)
      })
  },
  async fetchNewInvoicingCategory({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        GetNewModelController.get({ query: { model: 'invoicingCategory' } })
      )
      .then(async (response) => {
        commit('setInvoicingCategory', response.data.invoicingCategory)
      })
      .catch(async (reason) => {
        console.error('fetchNewInvoicingCategory', reason)
      })
  },
  // endregion

  // region store
  async storeNewInvoicingCategory({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        CreateInvoicingCategoryController.post(),
        payload.invoicing_category
      )
      .then(async (response) => {
        if (response.status === 201) {
          commit('setInvoicingCategory', response.data.invoicing_categories)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewInvoicingCategory', reason)
      })
  },
  // endregion

  // region update
  async updateInvoicingCategory({ commit }, payload) {
    console.log('action', payload.invoicing_category)
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateInvoicingCategoryController.put({
          invoicingCategory: payload.id
        }),
        payload.invoicing_category
      )
      .then(async (response) => {
        if (response.status === 201) {
          await commit(
            'setInvoicingCategoryList',
            response.data.invoicing_categories
          )
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updateInvoicingCategory', reason)
      })
  },
  // endregion

  // region update
  async updateMultipleInvoicingCategory({ commit }, payload) {
    console.log('action', payload)
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(UpdateMultipleInvoicingCategoryController.post(), payload)
      .then(async (response) => {
        if (response.status === 201) {
          await commit('setItemCategoryList', response.data.invoices_categories)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updateMultipleItemCategory', reason)
      })
  },
  // region delete
  async deleteInvoicingCategoryById({ commit }, payload) {
    await apiClient
      .route(
        DeleteInvoicingCategoryController.delete.delete({
          invoicingCategory: payload.id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit(
            'setInvoicingCategoryList',
            response.data.invoicing_categories
          )
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteInvoicingCategoryById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteInvoicingCategoryById({ commit }, payload) {
    await apiClient
      .route(DeleteInvoicingCategoryController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit(
            'setInvoicingCategoryList',
            response.data.invoicing_categories
          )
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteInvoicingCategoryById', reason)
      })
  }
  // endregion
}
